import React from 'react';
import { useHistory } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { BsArrowRepeat, BsCollection, BsPlus } from 'react-icons/bs';

const SORT_OPTIONS = [
  // Newest profile first, and listed first because it is the default — the thing you just
  // ran should be the thing you see at the top.
  ['recent', 'Last profiled'],
  ['risk', 'Risk'],
  ['size', 'Size'],
  ['width', 'Width'],
  ['depth', 'Depth'],
  ['age', 'Age'],
];

/**
 * Overview toolbar. The right side is the standard page Actions dropdown (same
 * pattern as PageHeader): "Refresh metadata" re-runs the profile jobs for the
 * selected identity's sources, "New profile…" opens the data-source picker.
 * The old Jobs drawer is gone — running jobs surface in the left-hand list.
 */
const MetadataToolbar = ({
  threshold,
  onThresholdChange,
  sort,
  onSortChange,
  onNewProfile,
  onRefresh,
  refreshEnabled,
}) => {
  const history = useHistory();
  return (
    <div className='metadata-toolbar'>
      <span className='mt-title'>Schema Intelligence</span>
      <span className='mt-sep'>|</span>
      <span className='mt-label'>Match ≥</span>
      <input
        type='range'
        min='50'
        max='100'
        value={threshold}
        onChange={(e) => onThresholdChange(Number(e.target.value))}
        aria-label='Minimum match threshold'
        data-testid='similarity-slider'
      />
      <span className='mt-value' data-testid='similarity-threshold'>{threshold}%</span>
      <span className='mt-sep'>|</span>
      <span className='mt-label'>Sort</span>
      <div style={{ display: 'flex', gap: 4 }}>
        {SORT_OPTIONS.map(([key, label]) => (
          <button
            key={key}
            type='button'
            className={'metadata-sortbtn' + (sort === key ? ' on' : '')}
            onClick={() => onSortChange(key)}
          >
            {label}
          </button>
        ))}
      </div>
      <button
        type='button'
        className='metadata-sortbtn'
        data-testid='metadata-open-library'
        style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 6 }}
        onClick={() => history.push('/metadata/library')}
        title='Browse the commercial schema fingerprint library'
      >
        <BsCollection />
        Schema Library
      </button>
      <div style={{ marginLeft: 12 }}>
        <Dropdown alignRight>
          <Dropdown.Toggle
            data-testid='metadata-actions-toggle'
            size='sm'
            className='pr-4 pl-4'
            variant='outline-secondary'
          >
            Actions
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              data-testid='metadata-action-refresh'
              disabled={!refreshEnabled}
              onClick={onRefresh}
              title={refreshEnabled
                ? 'Re-run the profile for every source in the selected identity'
                : 'Select an identity to refresh its metadata'}
            >
              <BsArrowRepeat className='mr-2' />
              Refresh metadata
            </Dropdown.Item>
            <Dropdown.Item
              data-testid='metadata-action-new-profile'
              onClick={onNewProfile}
            >
              <BsPlus className='mr-2' />
              New profile…
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default MetadataToolbar;
